import { render, staticRenderFns } from "./FrFormSpinbutton.vue?vue&type=template&id=2d3c7a4e&"
import script from "./FrFormSpinbutton.vue?vue&type=script&lang=js&"
export * from "./FrFormSpinbutton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports